import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/home/Home";
import Contact from "./components/contact/Contact";
import Classes from "./components/classes/Classes";
import Pricing from "./components/pricing/Pricing";
import Gallery from "./components/gallery/Gallery";
import Footer from "./components/footer/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/scrollToTop";
import { Analytics } from "@vercel/analytics/react";

const App = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
      <Analytics />
    </div>
  );
};

export default App;
